export async function applicationLoggedIn() {}

export async function applicationLoggedOut() {
    localStorage.clear();
}
